"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetTradePwdRequest = void 0;
var SetTradePwdRequest = /** @class */ (function () {
    function SetTradePwdRequest() {
    }
    return SetTradePwdRequest;
}());
exports.SetTradePwdRequest = SetTradePwdRequest;
;
//# sourceMappingURL=setTradePwd.request.js.map